import { render, staticRenderFns } from "./rectSwitch.vue?vue&type=template&id=9d0c2f70&scoped=true"
import script from "./rectSwitch.vue?vue&type=script&lang=js"
export * from "./rectSwitch.vue?vue&type=script&lang=js"
import style0 from "./rectSwitch.vue?vue&type=style&index=0&id=9d0c2f70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d0c2f70",
  null
  
)

export default component.exports